
import Methods from "./methods";

//Link da api auxiliar: https://convida-api-backup.herokuapp.com/
//Link da api develop : https://api-convida.herokuapp.com/
//Link da api produ: https://convida-api-official.herokuapp.com/
//Link da api OFICIAL ATUALMENTE (24/08): https://convida-refact-master.herokuapp.com/


let URL = "https://convida-refact-master.herokuapp.com/";

function fullUrl(aux) {
  let self = URL + aux;
  return self;
}

var entity;

export default URL;

//Professional
//Agent
//User
//Exam

/////////////////////////////////////////CLASSES/////////////////////////////////////////

export class agent {
  agentMethod = new Methods();
  constructor() {
    this.entity = fullUrl("agent");
  }

  //Geral
  create(par) {
    return this.agentMethod.create(this.entity, par);
  }
  //

  //Professional
  getProfessional(id) {
    return this.agentMethod.getProfessional(this.entity, id);
  }
  //Agent

  getAgent(id) {
    return this.agentMethod.getAgent(this.entity, id);
  }

  //User
  createUser(par) {
    return this.agentMethod.createUser(this.entity, par);
  }
  editUser(par, id) {
    return this.agentMethod.editUser(this.entity, par, id);
  }
  getAllAgentUsers(id, filter) {
    return this.agentMethod.getAllAgentUsers(this.entity, id, filter);
  }
  getUser(id) {
    return this.agentMethod.getUser(this.entity, id);
  }
  //

  //Exam
  createExam(par) {
    return this.agentMethod.createExam(this.entity, par);
  }
  editExam(par, id, op) {
    return this.agentMethod.editExam(this.entity, par, id, op);
  }
  getAllAgentExams(id, filter) {
    return this.agentMethod.getAllAgentExams(this.entity, id, filter);
  }
  getExam(id) {
    return this.agentMethod.getExam(this.entity, id);
  }
  getAllUserExams(id, filter) {
    return this.agentMethod.getAllUserExams(this.entity, id, filter);
  }
  //
}

export class professional {
  professionalMethod = new Methods();
  constructor() {
    this.entity = fullUrl("professional");
  }

  //Geral
  create(par) {
    return this.professionalMethod.create(this.entity, par);
  }
  //

  //Professional
  getProfessional(id) {
    return this.professionalMethod.getProfessional(this.entity, id);
  }

  //Agent
  getAllAgents(filter) {
    return this.professionalMethod.getAllAgents(this.entity, filter);
  }
  getAgent(id) {
    return this.professionalMethod.getAgent(this.entity, id);
  }

  //User
  getAllUsers(filter) {
    return this.professionalMethod.getAllUsers(this.entity, filter);
  }
  editUser(par, id, op) {
    return this.professionalMethod.editUser(this.entity, par, id, op);
  }
  getAllAgentUsers(id, filter) {
    return this.professionalMethod.getAllAgentUsers(this.entity, id);
  }
  getUser(id) {
    return this.professionalMethod.getUser(this.entity, id);
  }

  //Exam
  editExam(par, id, op) {
    return this.professionalMethod.editExam(this.entity, par, id, op);
  }
  getExam(id) {
    return this.professionalMethod.getExam(this.entity, id);
  }
  getAllExams(filter) {
    return this.professionalMethod.getAllExams(this.entity, filter);
  }
  getAllAgentExams(id, filter) {
    return this.professionalMethod.getAllAgentExams(this.entity, id, filter);
  }
  getAllUserExams(id, filter) {
    return this.professionalMethod.getAllUserExams(this.entity, id, filter);
  }
  getAllProfessionalExams(id, filter) {
    return this.professionalMethod.getAllProfessionalExams(this.entity, id, filter);
  }
}

export class organizer {
  organizerMethod = new Methods();
  constructor() {
    this.entity = fullUrl("organizer");
  }

  //Professional
  editProfessional(par, id) {
    return this.organizerMethod.editProfessional(this.entity, par, id);
  }
  getAllProfessionals(filter) {
    return this.organizerMethod.getAllProfessionals(this.entity, filter);
  }
  getProfessional(id) {
    return this.organizerMethod.getProfessional(this.entity, id);
  }
  deleteProfessional(id) {
    return this.organizerMethod.deleteProfessional(this.entity, id);
  }
  //

  //Agent
  editAgents(par, id) {
    return this.organizerMethod.editAgents(this.entity, par, id);
  }
  deleteAgents(id) {
    return this.organizerMethod.deleteAgents(this.entity, id);
  }
  getAllAgents(filter) {
    return this.organizerMethod.getAllAgents(this.entity, filter);
  }
  getAgent(id) {
    return this.organizerMethod.getAgent(this.entity, id);
  }
  //

  //User
  editUser(par, id) {
    return this.organizerMethod.editUser(this.entity, par, id);
  }
  getAllAgentUsers(id, filter) {
    return this.organizerMethod.getAllAgentUsers(this.entity, id, filter);
  }
  getUser(id) {
    return this.organizerMethod.getUser(this.entity, id);
  }
  //

  //Exam
  createExam(par) {
    return this.organizerMethod.createExam(this.entity, par);
  }
  editExam(par, id, op) {
    return this.organizerMethod.editExam(this.entity, par, id, op);
  }
  getExam(id) {
    return this.organizerMethod.getExam(this.entity, id);
  }
  getAllUserExams(id, filter) {
    return this.organizerMethod.getAllUserExams(this.entity, id, filter);
  }
  getAllExams(filter) {
    return this.organizerMethod.getAllExams(this.entity, filter);
  }
  getAllProfessionalExams(id, filter) {
    return this.organizerMethod.getAllProfessionalExams(this.entity, id, filter);
  }
  getAllAgentExams(id, filter) {
    return this.organizerMethod.getAllAgentExams(this.entity, id, filter);
  }
  //
}


export class password {
  passwordMethod = new Methods();
  constructor() {
    this.entity = fullUrl("password");
  }
  editProfessionalPassword(par, id) {
    return this.passwordMethod.editProfessionalPassword(this.entity, par, id);
  }
  editAgentPassword(par, id) {
    return this.passwordMethod.editAgentPassword(this.entity, par, id);
  }
}

export class email {
  emailMethod = new Methods();
  constructor() {
    this.entity = fullUrl("email");
  }
  createProfessionalEmail(par) {
    return this.emailMethod.createProfessionalEmail(this.entity, par);
  }
  createAgentEmail(par) {
    return this.emailMethod.createAgentEmail(this.entity, par);
  }
}

export class authenticate {
  authenticateMethod = new Methods();
  constructor() {
    this.entity = fullUrl("authenticate");
  }
  ProfessionalLogin(par) {
    return this.authenticateMethod.ProfessionalLogin(this.entity, par);
  }
  AgentLogin(par) {
    return this.authenticateMethod.AgentLogin(this.entity, par);
  }
}

